









































































































import Vue from 'vue';
import { mapGetters } from 'vuex';

import { QuoteState } from '@/models/quote';

import { IFetchPaymentPlansParams } from '@/services/payment-plan';
import QuotePicker from '../quote-common/QuotePicker.vue';

export default Vue.extend({
  components: { QuotePicker },
  name: 'PaymentPlanSearchFilter',

  props: {
    open: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      QuoteState,
      filterParams: {} as IFetchPaymentPlansParams
    };
  },

  computed: {
    ...mapGetters({
      paymentPlanStateList: 'paymentPlan/getPaymentPlanStateVisuals'
    }),

    openValue: {
      get(): boolean {
        return this.open;
      },
      set(val: boolean) {
        if (val === this.open) return;
        this.$emit('update:open', val);
      }
    }
  },

  methods: {
    closeSearchFilterDialog() {
      this.openValue = false;

      // reset filter params back to empty object
      this.resetFilterParams();
    },

    resetFilterParams() {
      this.filterParams = {};
    },

    openSearchFilterDialog(params: IFetchPaymentPlansParams) {
      if (params.quote__id != null) {
        this.filterParams.quote__id = params.quote__id;
      }

      if (params.state != null) {
        this.filterParams.state = params.state;
      }

      this.openValue = true;
    },

    save() {
      this.$emit('change', this.filterParams);
      this.closeSearchFilterDialog();
    }
  }
});
